<template>
  <el-row
    class="widget-col widget-view"
    :class="{ active: selectWidget.key && selectWidget.key == element.key }"
    @click.native.stop="handleSelectWidget(index)"
    type="flex"
    :gutter="element.options.gutter || 0"
    :justify="element.options.justifyContent"
    :align="element.options.alignItems"
  >
    <el-col
      v-for="(item, index) in element.columns"
      :key="index"
      :span="item.span || 0"
    >
      <draggable
        v-model="item.list"
        v-bind="{
          group: 'people',
          ghostClass: 'ghost',
          animation: 200,
          handle: '.drag-widget',
        }"
        @add="handleWidgetColAdd($event, element, index)"
      >
        <transition-group name="fade" tag="div" class="widget-col-list">
          <template v-for="(col, colindex) in item.list">
            <template v-if="col && col.key">
              <advanced-form-item
                v-if="Object.keys(advancedComponents).indexOf(col.type) >= 0"
                :key="col.key"
                :element="col"
                :select.sync="selectWidget"
                :index="colindex"
                :data="item"
                :data-config="dataConfig"
                @select-change="handleSelectChange($event, item)"
              >
              </advanced-form-item>

              <son-form
                v-else-if="col.type === 'sonform'"
                :key="col.key"
                :element="col"
                :select.sync="selectWidget"
                :index="colindex"
                :data="item"
                :data-config="dataConfig"
                @select-change="handleSelectChange($event, item)"
              >
              </son-form>

              <widget-col-item
                v-else-if="col.type === 'grid'"
                :key="col.key"
                :element="col"
                :select.sync="selectWidget"
                :index="colindex"
                :data="item"
                :data-config="dataConfig"
                @select-change="handleSelectChange($event, item)"
              >
              </widget-col-item>

              <widget-form-item
                v-else
                :key="col.key"
                :element="col"
                :select.sync="selectWidget"
                :index="colindex"
                :data="item"
                :data-config="dataConfig"
                @select-change="handleSelectChange($event, item)"
              >
              </widget-form-item>
            </template>
          </template>
        </transition-group>
      </draggable>
    </el-col>

    <div
      class="widget-view-action widget-col-action"
      v-if="selectWidget.key == element.key"
    >
      <i class="el-icon-delete" @click.stop="handleWidgetDelete(index)"></i>
    </div>

    <div
      class="widget-view-drag widget-col-drag"
      v-if="selectWidget.key == element.key"
    >
      <i class="su-icon-tuodong drag-widget"></i>
    </div>
  </el-row>
</template>

<script>
import WidgetFormItem from './WidgetFormItem'
import { advancedComponents } from './advanced/advanced.js'
import AdvancedFormItem from './advanced/AdvancedFormItem'
import SonForm from './advanced/sonfrom/SonForm'
import Draggable from 'vuedraggable'
import widgetFormUtils from '../util/widgetFormUtils'

export default {
  name: 'widget-col-item',
  components: {
    Draggable,
    WidgetFormItem,
    AdvancedFormItem,
    SonForm,
  },
  props: ['element', 'select', 'index', 'data', 'dataConfig'],
  data() {
    return {
      advancedComponents,
      selectWidget: this.select,
    }
  },
  methods: {
    handleSelectWidget(index) {
      this.selectWidget = this.data.list[index]
    },
    handleWidgetDelete(index) {
      if (this.data.list.length === 1) {
        this.$emit('select-change', -1)
      } else {
        if (this.data.list.length - 1 === index) {
          this.$emit('select-change', index - 1)
        } else {
          this.$emit('select-change', index)
        }
      }
      this.data.list.splice(index, 1)
    },

    handleWidgetColAdd($event, row, colIndex) {
      const newIndex = $event.newIndex

      const opt = row.columns[colIndex].list[newIndex].options
      if (Object.prototype.hasOwnProperty.call(opt, 'isShowSelect')) {
        opt.isShowSelect = true
      }

      widgetFormUtils.handleWidgetAdd(
        newIndex,
        null,
        row.columns[colIndex],
        this,
        false
      )
      this.selectWidget = row.columns[colIndex].list[newIndex]
    },
    handleSelectChange(index, item) {
      setTimeout(() => {
        index >= 0
          ? (this.selectWidget = item.list[index])
          : (this.selectWidget = {})
      }, 350)
    },
  },
  watch: {
    select(val) {
      this.selectWidget = val
    },
    selectWidget: {
      handler(val, oldVal) {
        if (JSON.stringify(val) !== JSON.stringify(oldVal)) {
          this.$emit('update:select', val)
        }
      },
      deep: true,
    },
  },
}
</script>

<style lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
